import * as React from 'react';

// Inputs outside a disabling provider keep their own disabled-state rules.
export const InputDisabledContext = React.createContext(false);

export const useInputDisabled = () => React.useContext(InputDisabledContext);
